import ServerListContainer from './containers/ServerListContainer';
import Typography from '@mui/material/Typography';

const ServerListView = () => (
  <>
    <Typography variant='h5' pb={2}>Kannel servers</Typography>
    <ServerListContainer />
  </>
);

export default ServerListView;
